import React, { useState } from "react";
import Input from "../../../components/Input";
import PageTitle from "../../../components/PageTitle";
import FormButton from "../../../components/FormButton";
import { checkMXRecords } from "../../../http/MXHttp";
import Spinner from "../../../components/Spinner";


const MXRecords = () => {

    const [file, setFile] = useState(false)
    const [isLoader, setIsLoading] = useState(false)
    const [search, setSearch] = useState('')
    
    function onFileChange(event) {
        setFile(event.target.files[0])
    }

    async function handleSearch() {
        setIsLoading(true)
        if (file) {
            const response = await checkMXRecords(file)
            if (!response) {
                alert('There is an issue with the file. Please try again...!')
                setIsLoading(false)
                return
            }
            console.log(response);
            // setDomainList(response.message)
            setIsLoading(false)
        }
        else {
            alert('Enter upload a file')
            setIsLoading(false)
        }

    }

    function onSearchChange(event) {
        setSearch(event.target.value)

        // if (fileInputRef.current) {
        //     fileInputRef.current.value = '';
        // }
    }

    return (

        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
            {isLoader ? <Spinner /> : null}

            <PageTitle title='MX Records' />
            {/* <Input type="file" name="file" id="domain" className=""
                style={{ margin: '5px' }} onChange={onFileChange} /> */}

            <Input type="text" name="domain" onChange={onSearchChange}
                value={search} id="domain" className="" style={{ margin: '5px' }} />

            <FormButton type="button"
                onClick={handleSearch} style={{ margin: '5px' }}
                className="btn btn-primary toolbar-item">Check Domain</FormButton>

        </div >
    );
};

export default MXRecords;
